import { render, staticRenderFns } from "./my-gold.vue?vue&type=template&id=53a5c5d3&scoped=true&"
import script from "./my-gold.vue?vue&type=script&lang=js&"
export * from "./my-gold.vue?vue&type=script&lang=js&"
import style0 from "./my-gold.vue?vue&type=style&index=0&id=53a5c5d3&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53a5c5d3",
  null
  
)

export default component.exports